import * as React from 'react';
import {PanZoom} from 'react-easy-panzoom';
import {CatalogPageEntity} from '../../../lib/Entity/CatalogPageEntity';
import {Page} from './Page';

interface PageGroupProps {
  pages: CatalogPageEntity[];
  onPanZoomChange: (panzoom: any) => void;
}

const MIN_ZOOM: number = 1;
const MAX_ZOOM: number = 3;

export class PageGroup extends React.Component<PageGroupProps, {}> {
  private containerRef: React.RefObject<HTMLDivElement> = React.createRef();
  // @ts-ignore
  private panZoomRef: React.RefObject<PanZoom> = React.createRef();

  componentDidMount(): void {
    if (this.containerRef.current) {
      this.containerRef.current.addEventListener('wheel', this.handleMouseWheel);
    }
  }

  componentWillUnmount(): void {
    if (this.containerRef.current) {
      this.containerRef.current.removeEventListener('wheel', this.handleMouseWheel);
    }
  }

  private handleMouseWheel = (e: WheelEvent) => {
    const {onPanZoomChange} = this.props;

    onPanZoomChange(this.panZoomRef.current);
  };

  private handlePreventPan = () => {
    if (this.panZoomRef.current) {
      return this.panZoomRef.current.state.scale <= 1;
    }

    return false;
  };

  private handleDoubleClick = () => {
    if (this.panZoomRef.current) {
      const scale = this.panZoomRef.current.state.scale;

      if (scale > MAX_ZOOM - 1) {
        this.panZoomRef.current.zoomOut(MAX_ZOOM * 100);
      }
    }
  };

  render() {
    const {pages, onPanZoomChange} = this.props;

    return (
      <div className='page-group-container swiper-slide' ref={this.containerRef}>
        <PanZoom
          minZoom={MIN_ZOOM}
          maxZoom={MAX_ZOOM}
          preventPan={this.handlePreventPan}
          onStateChange={() => {
            onPanZoomChange(this.panZoomRef.current);
          }}
          onDoubleClick={this.handleDoubleClick}
          ref={this.panZoomRef}
        >
          <div className='page-group-wrapper'>
            {pages.map(page => {
              return <Page key={page.id} page={page} />;
            })}
          </div>
        </PanZoom>
      </div>
    );
  }
}
